var React = require('react');

function IconWord (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1D1E22","fillRule":"evenodd","d":"M12.63 7.37V.1H1.96C1.25.11.68.68.68 1.39v24.76c0 .7.57 1.28 1.28 1.28h17.92c.71 0 1.28-.57 1.28-1.28V8.65h-7.25c-.7 0-1.28-.58-1.28-1.28zm3.04 6.4h1.28c.41 0 .71.38.62.78l-2.02 8.97c-.07.3-.33.5-.63.5H12.9c-.29 0-.55-.2-.62-.5l-.61-2.46a43.4 43.4 0 01-.6-2.53l-.07-.39-.08-.5h-.03c-.05.62-.1.84-.82 3.7l-.54 2.19a.64.64 0 01-.62.48H6.92c-.3 0-.56-.2-.63-.5l-2.01-8.96c-.1-.4.21-.78.62-.78h1.3c.31 0 .58.21.64.52a66.77 66.77 0 011.12 6.52c.07-.46.3-1.39 1.08-4.56l.49-1.99a.64.64 0 01.62-.49h1.55c.3 0 .56.2.63.5a152.17 152.17 0 011.57 6.77c-.01-.55-.04-1.25 1.16-6.76.05-.3.31-.51.61-.51zm5.5-6.83V6.6c0-.33-.14-.66-.38-.9L15.57.48a1.28 1.28 0 00-.91-.37h-.33v6.83h6.83z","clipRule":"evenodd"}));
}

IconWord.defaultProps = {"width":"35","height":"46","fill":"none","viewBox":"0 0 22 28"};

module.exports = IconWord;

IconWord.default = IconWord;
